import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    // Move focus to main content for keyboard/screen-reader users after navigation
    const id = window.requestAnimationFrame(() => {
      const main = document.getElementById("main-content");
      if (main && typeof main.focus === "function") {
        try {
          main.focus({ preventScroll: true });
        } catch {
          main.focus();
        }
      }
    });
    return () => window.cancelAnimationFrame(id);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;


